export default "__VITE_ASSET__b48ef1e6__"